export default __webpack_public_path__ + "static/media/result7.4baf9f4d.png";